import HelpTooltip from './HelpTooltip.jsx'

export default function StreakFlame({ streak = 0 }) {
  const lit = streak > 0
  return (
    <div className="flex items-center gap-2">
      <span
        className={`text-2xl ${lit ? 'animate-flame-flicker drop-shadow-[0_0_8px_rgba(248,170,27,0.6)]' : 'grayscale opacity-40'}`}
        aria-hidden="true"
      >
        🔥
      </span>
      <div className="flex flex-col leading-tight">
        <span className="text-lg font-bold text-brand-text">{streak}</span>
        <span className="text-xs text-brand-text-muted flex items-center gap-1">
          day streak
          <HelpTooltip label="What is a streak?">
            Consecutive days with at least one scoring activity logged.
          </HelpTooltip>
        </span>
      </div>
    </div>
  )
}
